import { Suspense, useMemo } from 'react';

import LocalizedDirection from 'dashboard/components/LocalizedDirection';
import ThemeEditorNavBack from 'dashboard/components/ThemeEditorNavBack';
import ThemeEditorTemplateSelector from 'dashboard/components/ThemeEditorTemplateSelector';
import ThemeSelector from 'dashboard/components/ThemeSelector';
import LoadingIndicator from 'dashboard/components-lib/LoadingIndicator';
import FormThemeEditorStartPage from 'dashboard/forms/FormThemeEditorStartPage';
import { Template } from 'dashboard/models/template';
import { Theme } from 'dashboard/models/theme';

interface DashboardEditorStartPageViewProps {
  handleSave: () => void;
  handleTemplateSelect: (templateId: string) => void;
  handleThemeSelect: (themeId: string) => void;
  currentLogoUrl?: string;
  loading: boolean;
  templates: Template[];
  templateSelectedPristine: Template;
  themes: Theme[];
  themeSelectedPristine: Theme;
  reactRouterV6?: boolean;
}

const DashboardEditorStartPageView = (props: DashboardEditorStartPageViewProps) => {
  const initialValues = useMemo(
    () => ({
      template: props.templateSelectedPristine?.attributes,
      theme: props.themeSelectedPristine.attributes,
    }),
    [props.themeSelectedPristine, props.templateSelectedPristine],
  );
  if (props.loading) {
    return <LoadingIndicator fullscreen={true} />;
  }
  return (
    <Suspense fallback={null}>
      <LocalizedDirection>
        <ThemeEditorNavBack reactRouterV6={props.reactRouterV6} />
        <ThemeEditorTemplateSelector
          handleTemplateSelect={props.handleTemplateSelect}
          templates={props.templates}
          value={props.templateSelectedPristine?.id}
        />
        <ThemeSelector
          handleThemeSelect={props.handleThemeSelect}
          themes={props.themes}
          themeSelectedPristine={props.themeSelectedPristine}
        />
        <FormThemeEditorStartPage
          currentLogoUrl={props.currentLogoUrl}
          initialValues={initialValues}
          keepDirtyOnReinitialize={false}
          onSubmit={props.handleSave}
        />
      </LocalizedDirection>
    </Suspense>
  );
};

export default DashboardEditorStartPageView;
